/**
 * Global Input Sanitization Configuration
 */

export const defaultSanitizationConfig = {
  // Whether sanitization is enabled globally
  enabled: true,

  // Show visual notification when characters are removed
  showNotifications: true,

  // How long to show notifications (milliseconds)
  notificationDuration: 3000,

  // CSS selectors for elements that should NOT be sanitized
  excludeSelectors: [
    '[data-no-sanitize="true"]',
    '[data-no-sanitize]',
    '.no-sanitize',
    '.code-editor',
    '[contenteditable="false"]',
  ],

  // Element-specific rules for newline preservation
  preserveNewlinesByElement: {
    'TEXTAREA': true,
    'INPUT': false,
    'DIV': true, // contenteditable divs
  },

  // Always preserve tabs (convert to spaces instead of removing)
  preserveTabs: false,

  // Callback fired when sanitization occurs
  onSanitize: null, // (original, cleaned, element) => {}

  // Callback fired when dangerous characters detected
  onDangerousInput: null, // (original, element) => {}

  // Enable console warnings in development
  devWarnings: process.env.NODE_ENV === 'development',

  // Notification styling
  notificationStyle: {
    position: 'fixed',
    top: '20px',
    right: '20px',
    backgroundColor: '#FEF3C7',
    border: '1px solid #F59E0B',
    color: '#92400E',
    padding: '12px 16px',
    borderRadius: '6px',
    fontSize: '14px',
    zIndex: '10000',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    maxWidth: '300px',
    animation: 'slideInRight 0.3s ease-out',
  },

  // Notification message
  notificationMessage: '⚠️ Hidden characters were removed from your input',
};

export default defaultSanitizationConfig;

